import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment.hmr';

@Injectable({
  providedIn: 'root'
})
export class AnexoReformaService {

  API = environment.API

  constructor(private http: HttpClient) { }

  post(body) {
    return this.http.post(`${this.API}AnexosReforma`, body);
  }

  put(body){
    return this.http.put(`${this.API}AnexosReforma`, body)
  }

  get(id: number) {
    return this.http.get(`${this.API}AnexosReforma/${id}`);
  }

  getAll() {
    return this.http.get(`${this.API}AnexosReforma`);
  }

  delete(id: number) {
    return this.http.delete(`${this.API}AnexosReforma/${id}`);
  }

}
